// extracted by mini-css-extract-plugin
export default {"header":"Table_header__czsUS","scrolled":"Table_scrolled__+3IcU"};